// @flow strict

import React from 'react';

export const CheckIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        width: '19px',
        height: '19px'
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0634 5.51227C9.78916 5.2381 9.34507 5.2381 9.07087 5.51227L6.27596 8.30614C6.00176 8.58031 6.00176 9.02521 6.27596 9.29939C6.55015 9.57356 6.99508 9.57356 7.26928 9.29939L10.0634 6.50467C10.3375 6.2305 10.3375 5.78644 10.0634 5.51227Z"
        fill="#FF6600"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.79158 7.01374C4.51739 7.28791 4.51739 7.73197 4.79158 8.00614L6.15834 9.3728C6.43253 9.64697 6.87663 9.64697 7.15082 9.3728C7.42501 9.09863 7.42501 8.65457 7.15082 8.38039L5.78406 7.01374C5.50987 6.73956 5.06577 6.73956 4.79158 7.01374Z"
        fill="#FF6600"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.28461 13.1005C10.4706 13.1005 13.0536 10.5177 13.0536 7.3319C13.0536 4.14527 10.4706 1.5625 7.28461 1.5625C4.09859 1.5625 1.51562 4.14527 1.51562 7.3319C1.51562 10.5177 4.09859 13.1005 7.28461 13.1005Z"
        stroke="#FF6600"
        strokeWidth="1.14745"
      />
    </svg>
  );
};